/**
 * Logger Utility
 * 
 * Provides consistent timestamped logging for debugging and monitoring.
 * Issue: #202
 */

/**
 * Format timestamp for logging
 */
function formatTimestamp(): string {
  const now = new Date()
  const hours = now.getHours().toString().padStart(2, '0')
  const minutes = now.getMinutes().toString().padStart(2, '0')
  const seconds = now.getSeconds().toString().padStart(2, '0')
  const millis = now.getMilliseconds().toString().padStart(3, '0')
  return `${hours}:${minutes}:${seconds}.${millis}`
}

/**
 * Log with timestamp prefix
 */
export function log(prefix: string, ...args: any[]): void {
  console.log(`[${formatTimestamp()}] ${prefix}`, ...args)
}

/**
 * Warn with timestamp prefix
 */
export function warn(prefix: string, ...args: any[]): void {
  console.warn(`[${formatTimestamp()}] ${prefix}`, ...args)
}

/**
 * Error with timestamp prefix
 */
export function error(prefix: string, ...args: any[]): void {
  console.error(`[${formatTimestamp()}] ${prefix}`, ...args)
}
